import './styles/style.css'

import { Amplify } from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom'

import config from './config'
import RootRouter from './content/RootRouter'
import * as serviceWorker from './serviceWorker'

Amplify.configure(config)

ReactDOM.render(
    <React.StrictMode>
        <RootRouter />
    </React.StrictMode>,
    document.getElementById('root')
)

serviceWorker.unregister()
